import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgxColorsModule } from 'ngx-colors';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'ig-color-picker',
  standalone: true,
  imports: [
    NgxColorsModule,
    FormsModule,
    CommonModule,
    MatIcon,
    MatTooltip
  ],
  templateUrl: './color.picker.component.html',
  styleUrl: './color.picker.component.scss'
})
export class ColorPickerComponent {
  @Input() color = '#fff';
  @Input() triggerText = 'color';
  @Input() triggerTextColor = this.color;
  @Input() isShowIndicator = true;

  @Output() change = new EventEmitter<string>();
  @Output() slider = new EventEmitter<string>();
  @Output() input = new EventEmitter<string>();
  @Output() close = new EventEmitter<string>();

  onChange($event: string) {
    this.change.emit($event);
  }

  onSlider($event: string) {
    this.slider.emit($event);
  }

  onInput($event: string) {
    this.slider.emit($event);
  }

  onClose($event: string) {
    this.close.emit($event);
  }

  onOpen($event: string) {
    const overlay = document.getElementById(('ngx-colors-overlay'));
    if (!overlay) {
      console.warn('No overlay found for color picker');
      return;
    }
    overlay.style.zIndex = `1000000`;  // greater than menu cdk overlay, so for TextAndColorComponent, clicking on the color picker does not close the menu
    overlay.onclick = (event) => {
      event.stopPropagation();
    };
  }
}
